'use strict';

import Glide from '@glidejs/glide';
import throttle from 'lodash.throttle';
import { DESKTOP_MIN_RESOLUTION } from '../utils/global.common';
import {debouncer} from "../utils/utils.common.js";

let sliderMediumCardsOptions = {
    gap: 32, 
    type: 'slider',
    animationDuration: 600,
    rewind: false,
    keyboard: true,
    perView: 3,
    startAt: 0,
    peek : {
        before: 0,
        after: 60,
    },
    bound: true,
    breakpoints: {
        771: {
            gap: 16,
            perView: 2,
            peek : {
                before: 0,
                after: 40,
            }
        }
    }
};

const sliderSmallCardsOptions = {
    type: 'slider',
    animationDuration: 600,
    rewind: false,
    gap: 32,
    keyboard: true,
    bound: true,
    startAt: 0,
    perView: 6,
    peek: {
        before: 0,
        after: 60
    },
    breakpoints: {
        1260: {
            perview: 4,
            peek : {
                before: 0, 
                after: 60
            }
        },
       
        1024: {
            perView: 3,
        },
        900: {
            perView: 3,
            peek : {
                before: 0,
                after: 50,
            }
        }
    }
};


const SliderComponent = {
    data() {
        return {
            isNavHidden: false,
            isDesktop: false,
            isMediumCards: false,
            numberOfSlidesPerView: 0,
            numberOfSlidesTotal: 0,
            overwriteSliderMediumCardsOptions: {} 
        };
    },
    methods: {
        updateNavVisibility() {
            this.numberOfSlidesPerView = this.carousel._o.perView;
            this.numberOfSlidesTotal = this.carousel._c.Sizes.length;

            this.isNavHidden = !this.carousel
                || this.carousel && this.numberOfSlidesPerView >= this.numberOfSlidesTotal;

            if (this.isNavHidden) {
                this.carousel.disable();
            } else {
                this.carousel.enable();
            }
        },
        areArrowsDisabled() {
            if(this.$refs.prevButton && this.$refs.nextButton) {
                return this.$refs.prevButton.classList.contains('glide__arrow--disabled')
                    && this.$refs.nextButton.classList.contains('glide__arrow--disabled');
            }
        },
        initCarousel() {
            this.isMediumCards = this.$refs.carousel.classList.contains(
                'slider-medium-container'
            );

            if (this.isMediumCards) {
                if(this.overwriteSliderMediumCardsOptions) {
                    sliderMediumCardsOptions = {...sliderMediumCardsOptions, ...this.overwriteSliderMediumCardsOptions};
                }

                this.carousel = new Glide(this.$refs.carousel, {
                    ...sliderMediumCardsOptions
                });
            } else if (this.isDesktop && !this.isMediumCards) {  
                this.carousel = new Glide(this.$refs.carousel, {
                    ...sliderSmallCardsOptions
                });
            }
        
            if (this.carousel) {
                this.carousel.on('resize', this.updateNavVisibility);

                this.carousel.on('mount.after', () => {
                    this.$root.$emit('slider.mount.after');
                });

                this.carousel.mount();
               
                this.updateNavVisibility();
            } else {
                this.isNavHidden = true;
            }
        },
        onResize() {
            this.isDesktop = window.innerWidth >= DESKTOP_MIN_RESOLUTION;

            if (!this.isMediumCards) {
                if (!this.isDesktop && this.carousel) {
                   
                    this.carousel.destroy();
                    this.carousel = null;
                    this.isNavHidden = true;
                } else if (!this.carousel) {
                    this.initCarousel();
                }
            }
        }
    },
    mounted() {   
		setTimeout(() => {
            if(this?.$refs?.carousel) {
                this.$el.classList.add("component-is-mounted");

                this.isDesktop = window.innerWidth >= DESKTOP_MIN_RESOLUTION;

                this.initCarousel();
                

                this.onResizeThrottled = throttle(this.onResize, 100);
                window.addEventListener('resize', debouncer(() => {
                    this.onResizeThrottled();
                }, 250));
            }
        }, 150);
    },
    destroyed() {
        this.carousel.on('resize', this.updateNavVisibility);
        window.removeEventListener('resize', this.onResizeThrottle);
    }
};

export default SliderComponent;